import { color } from '../color';
import { getValue } from '../../get-value';
export const colorBorderDefaultTokens = Object.freeze({
    'color.border': getValue(color, 'default.border.default'),
    'color.border.accent.red': getValue(color, 'default.border.accent.red'),
    'color.border.accent.orange': getValue(color, 'default.border.accent.orange'),
    'color.border.accent.yellow': getValue(color, 'default.border.accent.yellow'),
    'color.border.accent.green': getValue(color, 'default.border.accent.green'),
    'color.border.accent.teal': getValue(color, 'default.border.accent.teal'),
    'color.border.accent.blue': getValue(color, 'default.border.accent.blue'),
    'color.border.accent.purple': getValue(color, 'default.border.accent.purple'),
    'color.border.accent.magenta': getValue(color, 'default.border.accent.magenta'),
    'color.border.accent.gray': getValue(color, 'default.border.accent.gray'),
    'color.border.disabled': getValue(color, 'default.border.disabled'),
    'color.border.focused': getValue(color, 'default.border.focused'),
    'color.border.input': getValue(color, 'default.border.input'),
    'color.border.inverse': getValue(color, 'default.border.inverse'),
    'color.border.selected': getValue(color, 'default.border.selected'),
    'color.border.brand': getValue(color, 'default.border.brand'),
    'color.border.danger': getValue(color, 'default.border.danger'),
    'color.border.warning': getValue(color, 'default.border.warning'),
    'color.border.success': getValue(color, 'default.border.focused'),
    'color.border.discovery': getValue(color, 'default.border.discovery'),
    'color.border.information: ': getValue(color, 'default.border.information'),
    'color.border.bold': getValue(color, 'default.border.bold')
});
//# sourceMappingURL=color-border-default.js.map